import Component from '@glimmer/component';
import { service } from '@ember/service';
import { VStack } from 'tio-ui/components/layout';
import PageHero from 'tio-ui/components/page-hero';
import FilterTabs from 'tio-ui/components/filter-tabs';
import type { FilterTab } from 'tio-ui/components/filter-tabs';
import RepaymentOptionsConsolidation from 'tio-employee/components/repayment-options/consolidation';
import RepaymentOptionsRefinancing from 'tio-employee/components/repayment-options/refinancing';
import { PhArrowsLeftRight, PhArrowsMerge, PhArrowsClockwise } from 'ember-phosphor-icons';
import type RouterService from '@ember/routing/router-service';

const ROUTE_PREFIX = 'authenticated.repaying-student-debt.repayment-options';

const TABS: FilterTab[] = [
  { id: 'consolidation', label: 'Consolidation', icon: PhArrowsMerge },
  { id: 'refinancing', label: 'Refinancing', icon: PhArrowsClockwise },
];

export default class RepaymentOptionsPage extends Component {
  @service declare router: RouterService;

  tabs = TABS;

  get activeTab(): string {
    return this.router.currentRouteName === `${ROUTE_PREFIX}.refinancing`
      ? 'refinancing'
      : 'consolidation';
  }

  setTab = (id: string) => {
    const route = id === 'refinancing' ? `${ROUTE_PREFIX}.refinancing` : `${ROUTE_PREFIX}.index`;
    this.router.transitionTo(route);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  <template>
    {{! template-lint-disable no-bare-strings }}
    <VStack class="gap-8 pb-12">
      <PageHero
        @gradient="brand-soft"
        @icon={{PhArrowsLeftRight}}
        @title="Repayment Options"
        @subtitle="Explore consolidation and refinancing to find the best strategy for managing your student loans"
        class="tio-elevation-card-raised"
      />

      <FilterTabs
        @tabs={{this.tabs}}
        @activeId={{this.activeTab}}
        @onSelect={{this.setTab}}
        @showCounts={{false}}
      />

      {{#if (eq this.activeTab "consolidation")}}
        <RepaymentOptionsConsolidation @onSwitchToRefinancing={{this.setTab}} />
      {{else}}
        <RepaymentOptionsRefinancing />
      {{/if}}
    </VStack>
  </template>
}
